function PrivacyPolicy() {
  return (
    <div className="container py-5">
      <div className="card shadow-sm border-0">
        <div className="card-body p-4 p-md-5">

          <h1 className="border-bottom pb-3 mb-4">
            CRM Privacy Policy
          </h1>

          <p><strong>Effective Date:</strong> 21-07-2026</p>

          <p>
            This Privacy Policy describes how <strong>Sri Chaitanya CRM</strong> ("we", "our", or "us")
            collects, uses, and protects information when users access and use our Customer Relationship
            Management (CRM) application.
          </p>

          <h2 className="h4 mt-4">1. Scope of Service</h2>
          <p>
            This CRM is designed for internal organizational use. Access is restricted to authorized users within registered organizations.
          </p>

          <h2 className="h4 mt-4">2. Information We Collect</h2>

          <ul className="ps-4">
            <li><strong>User Information:</strong> Name, email address, phone number, role within organization</li>
            <li><strong>Customer Data:</strong> Contact details, interaction notes, and relationship history entered by users</li>
            <li><strong>Call Data:</strong> Call logs, timestamps, duration, and related metadata obtained via Airtel API integration</li>
            <li><strong>Usage Data:</strong> Login activity, system interactions, and audit logs</li>
            <li><strong>Device & Technical Data:</strong> IP address, browser type, operating system</li>
            <li><strong>Profile Media:</strong> Profile photos uploaded by users</li>
          </ul>

          <h2 className="h4 mt-4">3. Permissions and Device Access</h2>

          <p>
            Our application may request access to your device storage or photo library solely for the purpose of allowing you to upload or update your profile picture.
          </p>

          <ul className="ps-4">
            <li>Access is requested only when you choose to update your profile photo</li>
            <li>We do not access, scan, or collect other media files from your device</li>
            <li>Uploaded images are used only for profile display within the CRM</li>
          </ul>

          <p>
            This app does not access or use the device microphone. Call recordings are handled by the telecom provider (such as Airtel). The app only retrieves and displays call data via secure HTTPS connections and does not store recordings locally on the device.
          </p>

          <h2 className="h4 mt-4">4. Authentication and Security</h2>

          <p>
            We use JSON Web Token (JWT) based authentication to securely manage user sessions. Access to data is restricted based on organizational roles and permissions.
          </p>

          <h2 className="h4 mt-4">5. How We Use Information</h2>

          <ul className="ps-4">
            <li>To provide and operate CRM functionalities</li>
            <li>To manage customer relationships and communication records</li>
            <li>To track and analyze call activity through Airtel API integration</li>
            <li>To display user profile information including profile images</li>
            <li>To improve system performance and security</li>
            <li>To maintain audit logs and prevent unauthorized access</li>
          </ul>

          <h2 className="h4 mt-4">6. Data Sharing and Access Control</h2>

          <p>We do not sell personal data. Data access is limited as follows:</p>

          <ul className="ps-4">
            <li>Accessible only within the same organization</li>
            <li>Shared with service providers strictly for infrastructure and functionality</li>
            <li>Disclosed if required by law or regulatory authorities</li>
          </ul>

          <h2 className="h4 mt-4">7. Third-Party Services</h2>

          <p>We integrate with third-party services to provide certain functionalities:</p>

          <ul className="ps-4">
            <li><strong>Airtel API:</strong> Used to retrieve call logs and recordings. Airtel is responsible for the storage and management of call recordings.</li>
            <li>Other infrastructure or hosting providers may process data strictly on our behalf.</li>
          </ul>

          <p>
            These third-party services operate under their own privacy policies, and we encourage users to review them.
          </p>

          <h2 className="h4 mt-4">8. Data Storage and Backend</h2>

          <p>All data is securely stored and processed using our backend infrastructure built with Django.</p>

          <h2 className="h4 mt-4">9. Data Retention</h2>

          <p>We retain data only as long as necessary for operational, legal, and compliance purposes.</p>

          <h2 className="h4 mt-4">10. User Rights</h2>

          <ul className="ps-4">
            <li>Access and review their data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion where applicable</li>
          </ul>

          <h2 className="h4 mt-4">11. Cookies and Tracking</h2>

          <p>We may use cookies or similar technologies for authentication and improving user experience.</p>

          <h2 className="h4 mt-4">12. Children's Privacy</h2>

          <p>This CRM is not intended for individuals under 18.</p>

          <h2 className="h4 mt-4">13. Changes to This Policy</h2>

          <p>We may update this Privacy Policy periodically.</p>

          <h2 className="h4 mt-4">14. Contact Information</h2>

          <p><strong>Email:</strong> saransai.b@varsitymgmt.com</p>

          <h2 className="h4 mt-4">15. Call Data and Recordings</h2>

          <p>
            Our CRM integrates with external telecom service providers such as Airtel to retrieve call-related data.
          </p>

          <ul className="ps-4">
            <li>Call recordings and related data are managed and stored by the telecom provider (Airtel).</li>
            <li>Our application does not directly record or store call audio on user devices.</li>
            <li>The CRM only displays call recordings and associated metadata (such as call duration, timestamps, and contact details) as provided by the telecom service.</li>
            <li>We do not modify, process, or distribute call recordings beyond displaying them within the application.</li>
          </ul>

          <h2 className="h4 mt-4">16. User Consent</h2>

          <p>
            By using this application, users agree to the collection and use of information as described in this Privacy Policy.
          </p>

          <h2 className="h4 mt-4">17. Data Deletion</h2>

          <p>
            Users can request account and data deletion by contacting us at{" "}
            <a href="mailto:saransai.b@varsitymgmt.com">
              saransai.b@varsitymgmt.com
            </a>.
            Upon request, we will delete all associated data within a reasonable timeframe.
          </p>

          <p>
            This Privacy Policy is accessible within the application through the settings or legal section.
          </p>

        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
 